import styled from '@emotion/styled'
import { colors, metrics, zIndex } from 'component-library/__styling/settings'
import { Timestamp } from 'component-library/content/CardTimestamp/CardTimestamp'
import { calcRem, breakpointMax } from 'component-library/__styling/style-functions'
import { ArticleBlockContent } from '../ArticleBlockContent/ArticleBlockContent'
import { Button } from 'component-library/buttons/Button/Button'
import { IconSpinner } from 'component-library/icons/IconSpinner/IconSpinner'

export const StyledLiveBlogTimeline = styled('div')({
    borderLeft: `1px solid ${colors.thewest.greyDolphin}`,
})

export const StyledLiveBlogPost = styled('div')(({ theme }) => ({
    position: 'relative',
    paddingLeft: theme.margins.lg,
    paddingBottom: theme.margins.lg,
    marginTop: theme.margins.lg,

    '&::after': {
        display: 'block',
        position: 'absolute',
        borderRadius: '50%',
        content: `''`,
        left: -3,
        top: 5,
        width: 6,
        height: 6,
        backgroundColor: colors.thewest.westblue,
        zIndex: 11,
    },

    '&::before': {
        display: 'block',
        position: 'absolute',
        content: `''`,
        borderTop: `1px solid ${colors.thewest.greyDolphin}`,
        width: 20,
        left: 0,
        top: 7,
        zIndex: 10,
    },
}))

export const StyledLiveBlogTimestamp = styled(Timestamp)()

export const StyledLiveBlogAuthor = styled('span')({
    fontSize: calcRem(13),
    color: colors.thewest.greyElephant,
})

export const StyledArticleBlockContent = styled(ArticleBlockContent)({
    marginTop: metrics.thewest.margins.md,
})

export const StyledQuestionForm = styled('form')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
    paddingTop: metrics.thewest.margins.lg,
    backgroundColor: colors.white,
    padding: 10,

    [breakpointMax('md')]: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: zIndex.thewest.liveBlogQuestionForm,
        width: '100vw',
    },
})

export const StyledQuestionInput = styled('input')({
    padding: 6,
    flexGrow: 1,
})

export const StyledQuestionSubmit = styled(Button)()

export const StyledLoadMoreContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: calcRem(theme.margins.lg),
}))

export const StyledLoadMoreButton = styled(Button)()

export const StyledIconSpinner = styled(IconSpinner)({
    width: calcRem(30),
})

export const StyledConnectionStatus = styled('span')()
